import React from 'react';

const IndicatorsContext = React.createContext({

    adviserQuotations: null,
    totalQuotations: null,
    adviserEmissions: null,
    totalEmissions: null,
    adviserConversion: null,
    totalConversion: null,
    adviserAverageQuota: null,
    totalAverageQuota: null,

    advisersEmissionRanking: null,
    affinitiesEmissionRanking: null,
    handleModified: null,
    isReady: false

});

export default IndicatorsContext;